module.exports = __webpack_public_path__ + "static/img/f-750_2x3.8ce11052.webp";